export default {
  routeName: (state) => {
    return state.routeName;
  },

  postCheck: (state) => {
    return state.postCheck;
  },

  loginCheck: (state) => {
    return state.loginCheck;
  },
  checkCode: (state) => {
    return state.checkCode;
  },

  loginCode: (state) => {
    return state.loginCode;
  },
  loginBranch: (state) => {
    return state.loginBranch;
  },

  currentUser: state => {
    return state.currentUser;
  },

  userProfile: state => {
    return state.userProfile;
  },

  loadingBtn: state => {
    return state.loadingBtn;
  },

};
